import React from 'react';

type Props = {
  title: string;
  children?: React.ReactNode;
  icon?: React.ReactNode;
  eyebrow?: string;
  className?: string;
};

export default function FeatureCard({ title, children, icon, eyebrow, className = '' }: Props) {
  return (
    <article className={`relative overflow-hidden rounded-3xl border border-[#d9dbd2] bg-white/95 p-6 shadow-[0_20px_55px_-40px_rgba(7,26,49,0.7)] transition-all duration-300 hover:-translate-y-1 hover:border-[#2f5d48]/40 hover:shadow-[0_34px_70px_-38px_rgba(15,39,68,0.45)] ${className}`}>
      <div className="absolute right-4 top-4 rounded-full bg-[#f0f0eb] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-[#4f5b52]">Service</div>
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#ecefe7] text-2xl text-[#2f5d48]">
        {icon}
      </div>
      {eyebrow && <p className="mt-5 text-xs font-semibold uppercase tracking-[0.24em] text-[#2f5d48]">{eyebrow}</p>}
      <h3 className="mt-3 text-xl font-bold tracking-tight text-[#2f4f42]">{title}</h3>
      <p className="mt-3 text-sm leading-7 text-[#5e675f]">{children}</p>
      <div className="mt-6 h-px w-full bg-gradient-to-r from-[#9ab3a3] to-transparent" />
    </article>
  );
}
